import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useAxios } from "../../useAxios";
import { useTranslation } from "react-i18next";
import { App } from "antd";

export const useAddExamGroup = () => {
    const axios = useAxios();
    const queryClient = useQueryClient();
    const {t} = useTranslation();
    const {message} = App.useApp();

    const addExamGroup = async (examGroup: any) => {
        try {
            const response = await axios.post("/api/examgroup", examGroup);
            return response.data;
        } catch (error) {
            throw new Error(t("messages.error.addExamGroup"));
        }
    }

    return useMutation({mutationFn: addExamGroup, onSuccess: () => {
        queryClient.invalidateQueries({queryKey: ["examGroups"]});
        message.success(t("messages.success.addExamGroup"));
    }});
}